<div class="loading-overlay" role="status" aria-live="polite" aria-busy="true">
  <div class="loading-card">
    <span class="spinner-border text-primary" aria-hidden="true"></span>
    <strong>{{ message }}</strong>
    <span class="detail">Por favor espere.</span>
  </div>
</div>
